export function initAdsPoolSearch() {
  if (!document.querySelector('.ads-pool-searches')) return;

  function showFlash(message, type) {
    const cssClass = type === 'alert' ? 'alert-danger' : 'alert-success';
    $('#flash-container').html(
      '<div class="notice alert ' + cssClass + ' alert-dismissible fade show mt-3" role="alert">' + message + '</div>'
    );
  }

  function camelCaseToWords(s) {
    const result = s.replace(/([A-Z])/g, " $1").toLowerCase();
    return result.charAt(0).toUpperCase() + result.slice(1);
  }

  let data = {
    job_titles: [],
    locations: [],
    companies: [],
    schools: [],
    skills: [],
    years_of_experience: { min: null, max: null },
    years_of_graduation: { min: null, max: null },
    keywords: ""
  };

  function resetUIState() {
    const $searchBtn = $('.ads-pool-search-button');
    const $generateAudienceBtn = $('#ads-pool-generate-audience-btn');
    const $generateRawAudienceBtn = $('#ads-pool-generate-raw-audience-btn');
    const $createAdSetBtn = $('#ads-pool-create-adset-btn');
    const $saveAudienceBtn = $('#ads-pool-save-audience-btn');
    const $audienceNameInput = $('#ads-pool-audience-name');
    const $hitsSection = $('#ads-pool-search-hits .hits');

    $searchBtn.prop('disabled', false);
    $searchBtn.removeClass('disabled');

    $generateAudienceBtn.prop('disabled', true);
    $generateRawAudienceBtn.prop('disabled', true);
    $createAdSetBtn.prop('disabled', true);
    $saveAudienceBtn.prop('disabled', true);
    $generateAudienceBtn.addClass('disabled');
    $generateRawAudienceBtn.addClass('disabled');
    $createAdSetBtn.addClass('disabled');
    $saveAudienceBtn.addClass('disabled');
    $audienceNameInput.addClass('d-none').val('');

    $hitsSection.text('');

    $searchBtn.find('.spinner-border').addClass('d-none');
    $searchBtn.find('.content').removeClass('d-none');
    $generateAudienceBtn.find('.spinner-border').addClass('d-none');
    $generateAudienceBtn.find('.content').removeClass('d-none').text('Generate Audience CSV');
    $generateRawAudienceBtn.find('.spinner-border').addClass('d-none');
    $generateRawAudienceBtn.find('.content').removeClass('d-none').text('Generate Raw Data');
  }

  function clearAllFilters() {
    data = {
      job_titles: [],
      locations: [],
      companies: [],
      schools: [],
      skills: [],
      years_of_experience: { min: null, max: null },
      years_of_graduation: { min: null, max: null },
      keywords: ""
    };

    $('input[type="text"]').val('');
    $('textarea').val('');

    $('input[name="ads-pool-job-status"]').prop('checked', false);
    $('#ads-pool-job-status-current-or-past').prop('checked', true);

    $('input[name="ads-pool-location-status"]').prop('checked', false);
    $('#ads-pool-location-current').prop('checked', true);

    $('input[name="ads-pool-company-status"]').prop('checked', false);
    $('#ads-pool-company-status-current-or-past').prop('checked', true);

    $('#ads-pool-min-years-of-experience').val('0');
    $('#ads-pool-max-years-of-experience').val('30');
    $('#ads-pool-min-years-of-graduation').val('1973');
    $('#ads-pool-max-years-of-graduation').val('2033');

    $('.ads-pool-add-input').hide();
    $('.ads-pool-add-button').show();

    renderAddedItems();

    resetUIState();
  }

  function renderAddedItems() {
    $(".ads-pool-added-items").empty();

    data.job_titles.forEach(function(jobTitle, index) {
      const element = $("<div class='ads-pool-added-item'>")
        .html(`<b class='mr-1'>${jobTitle.text}</b><span>(${camelCaseToWords(jobTitle.filter)})</span>`)
        .attr("data-index", index);
      const close = $("<div>").addClass("ads-pool-close-button").html("<i class='far fa-minus-circle'></i>");
      element.append(close);

      element.click(function() {
        const indexToRemove = $(this).data("index");
        data.job_titles.splice(indexToRemove, 1);
        renderAddedItems();
      });

      $(".job-titles .ads-pool-added-items").append(element);
      $("input#ads-pool-job-title").val("");
    });

    data.locations.forEach(function(location, index) {
      const filterNames = {
        currentLocation: "Current",
        preferredNotCurrent: "Open to relocate only",
        preferredOrCurrent: "Current or open to relocate"
      };
      const element = $("<div class='ads-pool-added-item'>")
        .html(`<b class='mr-1'>${location.text}</b><span>(${filterNames[location.filter]})</span>`)
        .attr("data-index", index);
      const close = $("<div>").addClass("ads-pool-close-button").html("<i class='far fa-minus-circle'></i>");
      element.append(close);

      element.click(function() {
        const indexToRemove = $(this).data("index");
        data.locations.splice(indexToRemove, 1);
        renderAddedItems();
      });

      $(".locations .ads-pool-added-items").append(element);
    });

    data.companies.forEach(function(company, index) {
      const element = $("<div class='ads-pool-added-item'>")
        .html(`<b class='mr-1'>${company.text}</b><span>(${camelCaseToWords(company.filter)})</span>`)
        .attr("data-index", index);
      const close = $("<div>").addClass("ads-pool-close-button").html("<i class='far fa-minus-circle'></i>");
      element.append(close);

      element.click(function() {
        const indexToRemove = $(this).data("index");
        data.companies.splice(indexToRemove, 1);
        renderAddedItems();
      });

      $(".companies .ads-pool-added-items").append(element);
    });

    data.schools.forEach(function(text, index) {
      const element = $("<div class='ads-pool-added-item'>").text(text).attr("data-index", index);
      const close = $("<div>").addClass("ads-pool-close-button").html("<i class='far fa-minus-circle'></i>");
      element.append(close);

      element.click(function() {
        const indexToRemove = $(this).data("index");
        data.schools.splice(indexToRemove, 1);
        renderAddedItems();
      });

      $(".schools .ads-pool-added-items").append(element);
    });

    data.skills.forEach(function(text, index) {
      const element = $("<div class='ads-pool-added-item'>").text(text).attr("data-index", index);
      const close = $("<div>").addClass("ads-pool-close-button").html("<i class='far fa-minus-circle'></i>");
      element.append(close);

      element.click(function() {
        const indexToRemove = $(this).data("index");
        data.skills.splice(indexToRemove, 1);
        renderAddedItems();
      });

      $(".skills .ads-pool-added-items").append(element);
    });

    if (data.keywords.length) {
      const element = $("<div class='ads-pool-added-item'>").text(data.keywords);
      const close = $("<div>").addClass("ads-pool-close-button").html("<i class='far fa-edit'></i>");
      element.append(close);

      element.click(function() {
        $("#ads-pool-add-keywords .ads-pool-add-input").show();
        $(".keywords .ads-pool-added-items").empty();
        $("#ads-pool-add-keywords textarea").focus();
      });

      $(".keywords .ads-pool-added-items").append(element);
    }

    if (data.years_of_experience.min && data.years_of_experience.max) {
      const from = data.years_of_experience.min;
      const to = data.years_of_experience.max;
      const element = $("<div class='ads-pool-added-item'>").text(`${from} - ${to}`);
      const close = $("<div>").addClass("ads-pool-close-button").html("<i class='far fa-minus-circle'></i>");
      element.append(close);

      element.click(function() {
        data.years_of_experience = { min: null, max: null };
        $(".years-of-experience .ads-pool-added-items").empty();
        $("#ads-pool-add-years-of-experience .ads-pool-add-button").show();
      });

      $(".years-of-experience .ads-pool-added-items").append(element);
    }

    if (data.years_of_graduation.min && data.years_of_graduation.max) {
      const from = data.years_of_graduation.min;
      const to = data.years_of_graduation.max;
      const element = $("<div class='ads-pool-added-item'>").text(`${from} - ${to}`);
      const close = $("<div>").addClass("ads-pool-close-button").html("<i class='far fa-minus-circle'></i>");
      element.append(close);

      element.click(function() {
        data.years_of_graduation = { min: null, max: null };
        $(".years-of-graduation .ads-pool-added-items").empty();
        $("#ads-pool-add-years-of-graduation .ads-pool-add-button").show();
      });

      $(".years-of-graduation .ads-pool-added-items").append(element);
    }

    // Rule 4: Reset UI state when search criteria change
    resetUIState();
  }

  $(document).ready(function() {
    let prospectIds = [];
    let latestResultsCount = 0;
    renderAddedItems();

    $("#ads-pool-clear-filters-btn").click(function() {
      clearAllFilters();
    });

    $(".ads-pool-search-button").click(function() {
      const $btn = $(this);
      const $spinner = $btn.find('.spinner-border');
      const $content = $btn.find('.content');
      const $generateAudienceBtn = $('#ads-pool-generate-audience-btn');
      const $generateRawAudienceBtn = $('#ads-pool-generate-raw-audience-btn');
      const $createAdSetBtn = $('#ads-pool-create-adset-btn');
      const $saveAudienceBtn = $('#ads-pool-save-audience-btn');
      const $hitsSection = $('#ads-pool-search-hits .hits');

      const $audienceNameInput = $('#ads-pool-audience-name');

      $generateAudienceBtn.prop('disabled', true);
      $generateRawAudienceBtn.prop('disabled', true);
      $createAdSetBtn.prop('disabled', true);
      $saveAudienceBtn.prop('disabled', true);
      $generateAudienceBtn.addClass('disabled');
      $generateRawAudienceBtn.addClass('disabled');
      $createAdSetBtn.addClass('disabled');
      $saveAudienceBtn.addClass('disabled');
      $audienceNameInput.addClass('d-none').val('');

      $spinner.removeClass('d-none');
      $content.addClass('d-none');

      const hideSpinnerShowContent = () => {
        setTimeout(() => {
          $spinner.addClass('d-none');
          $content.removeClass('d-none');
        }, 500);
      };

      $.ajax({
        url: '/ads_pool_search',
        type: 'POST',
        contentType: 'application/json',
        data: JSON.stringify({ data: data }),
        success: function(response) {
          hideSpinnerShowContent();

          if (response.error) {
            latestResultsCount = 0;
            alert(response.error);

            $generateAudienceBtn.addClass('disabled');
            $generateRawAudienceBtn.addClass('disabled');
            $createAdSetBtn.addClass('disabled');
            $saveAudienceBtn.addClass('disabled');
            $generateAudienceBtn.prop('disabled', true);
            $generateRawAudienceBtn.prop('disabled', true);
            $createAdSetBtn.prop('disabled', true);
            $saveAudienceBtn.prop('disabled', true);
            $hitsSection.text('');
          } else {
            prospectIds = response.prospect_ids;
            const total = Number(response.results_count) || 0;
            const returned = response.returned_count;
            latestResultsCount = total;
            const hitsText = returned < total
              ? `Search Results: ${total.toLocaleString()} prospects (returning ${returned.toLocaleString()})`
              : `Search Results: ${total.toLocaleString()} prospects`;
            $hitsSection.text(hitsText);
            $generateAudienceBtn.prop('disabled', total === 0);
            $generateRawAudienceBtn.prop('disabled', total === 0);
            $createAdSetBtn.prop('disabled', total === 0);
            $saveAudienceBtn.prop('disabled', total === 0);

            if (total > 0) {
              $generateAudienceBtn.removeClass('disabled');
              $generateRawAudienceBtn.removeClass('disabled');
              $createAdSetBtn.removeClass('disabled');
              $saveAudienceBtn.removeClass('disabled');
              $audienceNameInput.removeClass('d-none');
            } else {
              $generateAudienceBtn.addClass('disabled');
              $generateRawAudienceBtn.addClass('disabled');
              $createAdSetBtn.addClass('disabled');
              $saveAudienceBtn.addClass('disabled');
              $audienceNameInput.addClass('d-none');
            }
          }
        },
        error: function(error) {
          hideSpinnerShowContent();
          alert(error.responseJSON.error || 'Error performing search');
        }
      });
    });

    function pollGenerationStatus(jobId, exportType, $btn, $spinner, $content, $otherBtn, $createAdSetBtn, $saveAudienceBtn) {
      const isRaw = exportType === 'raw';

      const restoreButtons = () => {
        $spinner.addClass('d-none');
        $content.removeClass('d-none');
        $btn.prop('disabled', false);
        $otherBtn.prop('disabled', false);
        $createAdSetBtn.prop('disabled', false);
        $saveAudienceBtn.prop('disabled', false);
      };

      $spinner.removeClass('d-none');
      $content.addClass('d-none');
      $content.text('Generating...');

      const pollInterval = setInterval(() => {
        $.ajax({
          url: `/ads_pool_search/generation_status/${jobId}`,
          type: 'GET',
          success: function(response) {
            switch(response.status) {
              case 'complete':
                clearInterval(pollInterval);
                triggerDownload(jobId, isRaw);
                restoreButtons();
                $content.text(isRaw ? 'Generate Raw Data' : 'Generate Audience CSV');
                break;
              case 'error':
                clearInterval(pollInterval);
                alert(`Error generating CSV: ${response.error_message || 'Unknown error'}`);
                restoreButtons();
                $content.text(isRaw ? 'Generate Raw Data' : 'Generate Audience CSV');
                break;
              case 'processing':
                $content.text('Processing...');
                break;
              case 'queued':
                $content.text('Queued...');
                break;
            }
          },
          error: function(xhr) {
            clearInterval(pollInterval);
            alert('Error checking generation status');
            restoreButtons();
            $content.text(isRaw ? 'Generate Raw Data' : 'Generate Audience CSV');
          }
        });
      }, 10000);
    }

    function triggerDownload(jobId, isRaw) {
      const downloadUrl = `/ads_pool_search/download_audience/${jobId}`;
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.style.display = 'none';

      const filename = isRaw ? 'ads_pool_raw_' : 'ads_pool_audience_';
      link.download = `${filename}${new Date().toISOString().replace(/[-:T.]/g, '')}.csv`;

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }

    $("#ads-pool-generate-audience-btn, #ads-pool-generate-raw-audience-btn").click(function (e) {
      const $btn = $(e.currentTarget);
      const $spinner = $btn.find('.spinner-border');
      const $content = $btn.find('.content');
      const $otherBtn = $btn.attr('id') === 'ads-pool-generate-raw-audience-btn' ? $('#ads-pool-generate-audience-btn') : $('#ads-pool-generate-raw-audience-btn');
      const $createAdSetBtn = $('#ads-pool-create-adset-btn');
      const $saveAudienceBtn = $('#ads-pool-save-audience-btn');

      const isRaw = $btn.attr('id') === 'ads-pool-generate-raw-audience-btn';
      const exportType = isRaw ? 'raw' : 'audience';

      $spinner.removeClass('d-none');
      $content.addClass('d-none');
      $btn.prop('disabled', true);
      $otherBtn.prop('disabled', true);
      $createAdSetBtn.prop('disabled', true);
      $saveAudienceBtn.prop('disabled', true);

      const restoreButtons = () => {
        $spinner.addClass('d-none');
        $content.removeClass('d-none');
        $btn.prop('disabled', false);
        $otherBtn.prop('disabled', false);
        $createAdSetBtn.prop('disabled', false);
        $saveAudienceBtn.prop('disabled', false);
        $searchBtn.prop('disabled', false);
        $searchBtn.removeClass('disabled');
      };

      $.ajax({
        url: '/ads_pool_search/generate_audience',
        type: 'POST',
        contentType: 'application/json',
        data: JSON.stringify({ data: data, export_type: exportType }),
        success: function(response) {
          pollGenerationStatus(response.job_id, exportType, $btn, $spinner, $content, $otherBtn, $createAdSetBtn, $saveAudienceBtn);
        },
        error: function(error) {
          console.log(error);
          const errorMsg = (error.responseJSON && error.responseJSON.error) || 'Error starting CSV generation';
          alert(errorMsg);
          restoreButtons();
        }
      });
    });

    $("#ads-pool-save-audience-btn").click(function() {
      const $btn = $(this);
      const candidatesCount = latestResultsCount;

      const name = $('#ads-pool-audience-name').val();
      if (!name || !name.trim()) {
        $('#ads-pool-audience-name').focus();
        return;
      }

      $btn.prop('disabled', true);

      $.ajax({
        url: '/ads_pool_search/save_audience',
        type: 'POST',
        contentType: 'application/json',
        data: JSON.stringify({ name: name.trim(), data: data, candidates_count: candidatesCount }),
        success: function(response) {
          showFlash(response.message, 'notice');
          $btn.prop('disabled', false);
          clearAllFilters();
        },
        error: function(error) {
          const errorMsg = (error.responseJSON && error.responseJSON.error) || 'Error saving audience';
          showFlash(errorMsg, 'alert');
          $btn.prop('disabled', false);
        }
      });
    });

    $("#ads-pool-create-adset-btn").click(function() {
      if (prospectIds.length === 0) {
        alert('No prospects to create AdSet for');
        return;
      }

      $.ajax({
        url: '/ads_pool_search/create_adset',
        type: 'POST',
        contentType: 'application/json',
        data: JSON.stringify({ data: data }),
        success: function(response) {
          if (response.success) {
            alert(response.message);
            window.location.href = response.redirect_url;
          } else {
            alert(response.error || 'Unknown error');
          }
        },
        error: function(error) {
          console.log(error);
          const response = error.responseJSON || {};
          alert(response.error || 'Error creating audience');
        }
      });
    });

    $(".ads-pool-add-container .ads-pool-add-button").click(function() {
      const container = $(this).parent();
      $(this).hide();
      const input = $(container).find(".ads-pool-add-input");
      input.show();

      $(document).mousedown(function(e) {
        if (["ads-pool-add-keywords", "ads-pool-add-years-of-experience", "ads-pool-add-years-of-graduation"].includes(container.attr("id"))) {
          return;
        }
        if (!container.is(e.target) && container.has(e.target).length === 0) {
          $(container).find(".ads-pool-add-input").hide();
          $(container).find(".ads-pool-add-button").show();
        }
      });
    });

    const saveYearsOfExperience = () => {
      const min = $("#ads-pool-min-years-of-experience").val() || 0;
      const max = $("#ads-pool-max-years-of-experience").val() || 30;
      data.years_of_experience.min = min;
      data.years_of_experience.max = max;
      $("#ads-pool-add-years-of-experience .ads-pool-add-input").hide();
      $("#ads-pool-add-years-of-experience .ads-pool-add-button").show();
    };

    const saveYearsOfGraduation = () => {
      const min = $("#ads-pool-min-years-of-graduation").val() || 0;
      const max = $("#ads-pool-max-years-of-graduation").val() || 30;
      data.years_of_graduation.min = min;
      data.years_of_graduation.max = max;
      $("#ads-pool-add-years-of-graduation .ads-pool-add-input").hide();
      $("#ads-pool-add-years-of-graduation .ads-pool-add-button").show();
    };

    $(".ads-pool-add-input input").on("keypress", function(e) {
      const id = $(this).closest(".ads-pool-add-container").attr("id");
      const textElem = $(this).closest(".ads-pool-add-container").find(".ads-pool-add-input input[type='text']");

      if (e.which == 13) {
        e.preventDefault();

        if (id === "ads-pool-add-job-titles") {
          const text = $(textElem).val();
          const filter = $('input[name="ads-pool-job-status"]:checked').val();
          data.job_titles = [...data.job_titles, { text, filter }];
        } else if (id === "ads-pool-add-locations") {
          const text = $(textElem).val();
          const filter = $('input[name="ads-pool-location-status"]:checked').val();
          data.locations = [...data.locations, { text, filter }];
        } else if (id === "ads-pool-add-companies") {
          const text = $(textElem).val();
          const filter = $('input[name="ads-pool-company-status"]:checked').val();
          if (data.companies.length < 20) {
            data.companies = [...data.companies, { text, filter }];
          } else {
            alert("Maximum 20 companies");
          }
        } else if (id === "ads-pool-add-schools") {
          const text = $(textElem).val();
          data.schools = [...data.schools, text];
        } else if (id === "ads-pool-add-skills") {
          data.skills = [...data.skills, $(textElem).val()];
        } else if (id === "ads-pool-add-years-of-experience") {
          saveYearsOfExperience();
        } else if (id === "ads-pool-add-years-of-graduation") {
          saveYearsOfGraduation();
        } else {
          alert("Not implemented yet");
        }

        renderAddedItems();
        if (id !== "ads-pool-add-years-of-experience" && id !== "ads-pool-add-years-of-graduation") {
          $(textElem).val("");
        }
      }
    });

    $("#ads-pool-add-years-of-experience .ads-pool-save-button").click(function() {
      saveYearsOfExperience();
      renderAddedItems();
    });

    $("#ads-pool-add-years-of-graduation .ads-pool-save-button").click(function() {
      saveYearsOfGraduation();
      renderAddedItems();
    });

    $(".ads-pool-add-input textarea").on("keypress", function(e) {
      if (e.which == 13) {
        e.preventDefault();
        submitKeywords($(this));
      }
    });

    $("#ads-pool-submit-keywords").click(function() {
      submitKeywords($("#ads-pool-add-keywords textarea"));
    });

    $("#ads-pool-remove-keywords").click(function() {
      data.keywords = "";
      $("#ads-pool-add-keywords textarea").val("");
      renderAddedItems();
      $("#ads-pool-add-keywords .ads-pool-add-input").hide();
      $("#ads-pool-add-keywords .ads-pool-add-button").show();
    });

    function submitKeywords(textareaElement) {
      const container = textareaElement.closest(".ads-pool-add-container");
      const text = textareaElement.val();
      data.keywords = text;
      $(container).find(".ads-pool-add-input").hide();
      if (text.length) {
        $(container).find(".ads-pool-add-button").hide();
      } else {
        $(container).find(".ads-pool-add-button").show();
      }
      renderAddedItems();
      textareaElement.blur();
    }
  });
}
